
import * as OM from '@/model';
import { Options, Vue } from 'vue-class-component';
import { StorageServices } from '@/services/StorageServices';
import {VillageConfigClient} from '@/services/Services';
import store from '@/store';

@Options({})
export default class leftMenu extends Vue {

    showLeftMenu: boolean = false;
    villageMenuVmList: OM.VillageMenuVm[] = [];

    created(){
        VillageConfigClient.getVillageMenuVm()
        .then(x => {
            this.villageMenuVmList = x;
        })
    }

    goToAreaSoci(){
        if(store.state.clubSubscription || store.state.agentSubscription){
            this.setLastSoci(true);
            this.$router.push('/network/home');
        } else {
            this.$router.push('/network/clubSubscription');
        }
    }

    setLastSoci(value){
        StorageServices.setLastVisitedAreaSoci(value);
    }

    selectVillage(item: OM.LocalizedNameIdentifier){
        this.setLastSoci(false)

        VillageConfigClient.getById(item.identifier)
        .then(x => {
            store.state.villageConfig = x;

            this.$router.push('/village/home');
        })
    }


}
